import { render, staticRenderFns } from "./CartaPaxSends.vue?vue&type=template&id=bd5d3754&scoped=true&"
import script from "./CartaPaxSends.vue?vue&type=script&lang=js&"
export * from "./CartaPaxSends.vue?vue&type=script&lang=js&"
import style0 from "./CartaPaxSends.vue?vue&type=style&index=0&id=bd5d3754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5d3754",
  null
  
)

export default component.exports